module.exports = __webpack_public_path__ + "static/media/dorvenfoods.58d41a0b.png";